import { PlaceReview } from "@/types/place"
import { cn } from "cn"
import pluralize from "pluralize"

import { Badge } from "./ui/badge"
import { Tooltip, TooltipContent, TooltipTrigger } from "./ui/tooltip"

export function ReviewHighlights({
  review,
  className,
}: {
  review: PlaceReview
  className?: string
}) {
  const isRemoved = review.hidden_is_terminal === true
  const isModeratedOut = Boolean(review.hidden_reason_category)
  const hasSuppressedPhotos = (review.suppressed_photo_count || 0) > 0
  if (
    !review.highlights?.length &&
    !review.is_pending_moderation &&
    !isRemoved &&
    !isModeratedOut &&
    !hasSuppressedPhotos
  ) {
    return null
  }

  return (
    <div className={cn("flex flex-wrap gap-1.5", className)}>
      {isRemoved ? (
        <Tooltip>
          <TooltipTrigger
            render={
              <Badge color="red" size={1} className="cursor-default">
                Removed
              </Badge>
            }
          />
          <TooltipContent>
            This review was removed for violating content rules
          </TooltipContent>
        </Tooltip>
      ) : (
        (isModeratedOut || review.is_pending_moderation) && (
          <Tooltip>
            <TooltipTrigger
              render={
                <Badge color="light-yellow" size={1} className="cursor-default">
                  {isModeratedOut ? "Hidden" : "In review"}
                </Badge>
              }
            />
            <TooltipContent>
              {isModeratedOut
                ? "This review was hidden after moderation"
                : "We’re checking this review before it’s published"}
            </TooltipContent>
          </Tooltip>
        )
      )}
      {hasSuppressedPhotos && (
        <Tooltip>
          <TooltipTrigger
            render={
              <Badge color="light-yellow" size={1} className="cursor-default">
                Photos removed
              </Badge>
            }
          />
          <TooltipContent>
            {`${pluralize("photo", review.suppressed_photo_count, true)} were removed for content safety.`}
          </TooltipContent>
        </Tooltip>
      )}
      {(review.highlights || []).map((highlight) => (
        <Badge key={highlight} color="muted" size={1}>
          {highlight}
        </Badge>
      ))}
    </div>
  )
}
